export const CONSTANTS = {
    localStorage: {
        token: 'token'
    }
}